export default __webpack_public_path__ + "static/media/content-1-2.ddb839fd.svg";